import "./portfolio.css";

export default function Portfolio() {
  return (
    <div id="portfolio">
      <div className="pl-texts">
        <h1 className="pl-title">My Portfolio</h1>
        <p className="pl-desc">Here are some examples of projects I've worked on. Please click the "demo button" to view the full website!</p>
      </div>
      <div className="pl-list">
        <div className="pl-item">
          <img src="images/projects/infimech.jpg" alt="infimech" />
          <div className="pl-name">Infimech</div>
          <a href="https://infimech.co.id/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/kalpika.jpg" alt="kalpika" />
          <div className="pl-name">Kalpika</div>
          <a href="https://kalpika.id/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/gapara.jpg" alt="gapara" />
          <div className="pl-name">Gapara</div>
          <a href="https://www.gapara.co.id/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/fit_club.jpg" alt="fit club" />
          <div className="pl-name">The Fit Club</div>
          <a href="https://fitness-zainal.netlify.app" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/music_app.jpg" alt="music app" />
          <div className="pl-name">Music App</div>
          <a href="https://music-zainal.netlify.app/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/best_eats.jpg" alt="best eats" />
          <div className="pl-name">Best Eats</div>
          <a href="https://best-eats-zainal.netlify.app/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/gaps.jpg" alt="gaps" />
          <div className="pl-name">GAPS</div>
          <a href="https://app.gapara.co.id/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/kaps.jpg" alt="kaps" />
          <div className="pl-name">KAPS</div>
          <a href="https://app.kalpika.net/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        <div className="pl-item">
          <img src="images/projects/bkd.jpg" alt="bankamda" />
          <div className="pl-name">Bankamda</div>
          <a href="https://web.kalpika.id/" target="_blank" rel="noreferrer">
            <button>Demo</button>
          </a>
        </div>
        {/* <div className="pl-item">
					<img src="images/projects/hospital.jpg" alt="" />
					<div className="pl-name">Hospital</div>
					<a href="https://zainal-hospital.vercel.app/login" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div> */}
        {/* <div className="pl-item">
					<img src="images/projects/kotama.jpg" alt="" />
					<div className="pl-name">Kotama App</div>
					<a href="https://kotama.vercel.app/" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div> */}
        {/* <div className="pl-item">
					<img src="images/projects/survey.jpg" alt="" />
					<div className="pl-name">Survey Website</div>
					<a href="https://zainal-survey.vercel.app/" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div> */}
        {/*
				<div className="pl-item">
					<img src="images/projects/zainal-blog.jpg" alt="" />
					<div className="pl-name">My Blog</div>
					<a href="https://zainal-blog.herokuapp.com/" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div>
				*/}
        {/* <div className="pl-item">
					<img src="images/projects/zainal-quiz.jpg" alt="" />
					<div className="pl-name">Who Wants to Be a Millionaire!</div>
					<a href="https://zainal-quiz.vercel.app/" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div> */}
        {/* <div className="pl-item">
					<img src="images/projects/zainal-candycrush.jpg" alt="" />
					<div className="pl-name">Candy Crush Game</div>
					<a href="https://zainal-candycrush.vercel.app/" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div> */}
        {/* <div className="pl-item">
					<img src="images/projects/zainal-2048game.jpg" alt="" />
					<div className="pl-name">2048 Game</div>
					<a href="https://zainal-2048.vercel.app/" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div> */}
        {/* <div className="pl-item">
					<img src="images/projects/zainal-flagsmemorygame.jpg" alt="" />
					<div className="pl-name">Flags Memory Game</div>
					<a href="https://flagsmemorygame.vercel.app/" target="_blank" rel="noreferrer">
						<button>Demo</button>
					</a>
				</div> */}
      </div>
    </div>
  );
}
